import React from 'react';
import { Container } from '@antonpodolsky/design-system/layout/container/container';
import { Divider } from '@antonpodolsky/design-system/layout/divider/divider';

export const HomepageDivider = () => (
  <Container bleed>
    <Divider />
  </Container>
);
